import {ToolOpinion} from "@/entities/ToolOpinion";

export class Recommendation {
    tool: ToolOpinion;
    approvalPercentage: number;

    constructor(tool: ToolOpinion, approvalPercentage: number) {
        this.tool = tool;
        this.approvalPercentage = approvalPercentage;
    }
}
